<template>
    <div>
        <h2 class="text-1xl font-bold text-gray-700">
          Listado de traslados internos
        </h2>
      <ListInternalTransferOfProducts />
    </div>
  </template>
  
  <script>
  import ListInternalTransferOfProducts from "@/components/InternalTransferOfProducts/ListInternalTransferOfProducts.vue";
  import { useRoute } from "vue-router";
  import { onBeforeMount, onMounted } from "vue";
  import { findSubmoduleIdByDescription } from "@/hisAcces";
  export default {
    name: "ListInternalTransferOfProductsView",
    components: {
        ListInternalTransferOfProducts,
    },
    setup() {
      const route = useRoute();
      onBeforeMount(() => {
        if (!findSubmoduleIdByDescription(route.path)) {
          window.location.href = "/login";
        }
      });
  
      onMounted(() => {
        document.title =
          route.meta.title + process.env.VUE_APP_TITLE ||
          process.env.VUE_APP_TITLE;
      });
    },
  };
  </script>
  